if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			// Gallery thumbnails

			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).offsetTop + this.offsetTop,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('change', e=>{
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				if ( this.productGallery.dataset.jsDisableParallax == 'false' ) {
					this.productSlider.addEventListener('ready', (e)=>{
						
						if ( this.firstProductGalleryIndex ) {
							this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
						}

						const productSlides = this.productSlider.querySelectorAll('.product-gallery-item');
						const productFigures = this.querySelectorAll('.apply-gallery-animation');
						this.productSlider.addEventListener('scroll', ()=>{
							const scrollX = -this.productSlider.element.scrollLeft;
							productSlides.forEach((slide,i)=>{
								const media = productFigures[i];
								if ( media ) {
									media.style.transform = `translateX(${( slide.offsetLeft + scrollX ) * -1/3}px)`;
								}
							});
						});

					});
				}

			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action == 'overlay' || KROWN.settings.cart_action == 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			if ( window.MilesSubscriptionWidget ) {
				window.MilesSubscriptionWidget.init(this);
			} else {
				this.subscriptionCustomerInteracted = false;
				this.subscriptionCustomerInteractedAt = 0;
				this.subscriptionPurchasePreference = 'one_time';
				this.subscriptionSellingPlanGroupValue = '';
				this.subscriptionPreferenceRequestedAt = 0;
				this.subscriptionPreferenceUntil = 0;
				this.subscriptionPreferenceRespectCustomerInteraction = false;
				this.subscriptionPreferenceToApply = 'one_time';
				this.addEventListener('pointerdown', event=>{
					if ( event.isTrusted && event.target.closest('.shopify_subscriptions_app_container') ) {
						this.subscriptionCustomerInteracted = true;
						this.subscriptionCustomerInteractedAt = Date.now();
					}
				}, true);
				this.addEventListener('change', event=>{
					if ( ! event.isTrusted || ! event.target.closest('.shopify_subscriptions_app_container') ) {
						return;
					}

					if ( event.target.matches('input[data-radio-type="one_time_purchase"]') ) {
						this.subscriptionPurchasePreference = 'one_time';
					} else if ( event.target.matches('input[data-radio-type="selling_plan_group"]') ) {
						this.subscriptionPurchasePreference = 'subscription';
						this.subscriptionSellingPlanGroupValue = event.target.value || event.target.id || '';
					} else if ( event.target.matches('input[name="selling_plan"], select[name="selling_plan"]') && event.target.value !== '' ) {
						this.subscriptionPurchasePreference = 'subscription';
					}
				}, true);

				this.updateSubscriptionPolicyIntro();
				const subscriptionObserver = new MutationObserver(()=>{
					this.updateSubscriptionPolicyIntro();
					if ( this.subscriptionPreferenceUntil > Date.now() ) {
						this.runApplySubscriptionPreference(
							this.subscriptionPreferenceRequestedAt,
							this.subscriptionPreferenceRespectCustomerInteraction
						);
					}
				});
				subscriptionObserver.observe(this, { childList: true, subtree: true });

				this.requestApplySubscriptionPreference({
					preference: 'one_time',
					delays: [500, 1000, 2000, 4000],
					respectCustomerInteraction: true
				});
				this.querySelectorAll('form[action*="/cart/add"]').forEach(form=>{
					form.addEventListener('submit', ()=>{
						if ( this.isOneTimeSubscriptionSelected() ) {
							this.clearSubscriptionSellingPlan();
						}
					}, true);
				});
			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});
			}

		}

		getActiveSubscriptionBlock(){
			return this.querySelector('.shopify_subscriptions_app_block:not(.shopify_subscriptions_app_block--hidden)');
		}

			updateSubscriptionPolicyIntro(){
				const textWalker = document.createTreeWalker(this, NodeFilter.SHOW_TEXT, {
					acceptNode: node=>{
						if ( node.parentElement && node.parentElement.closest('script, style') ) {
							return NodeFilter.FILTER_REJECT;
						}
						return /Auto-renews|Pause or cancel anytime to suit you/i.test(node.nodeValue) ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
					}
				});
				let textNode = textWalker.nextNode();

				while ( textNode ) {
					textNode.nodeValue = textNode.nodeValue.replace(/Auto-renews,\s*skip or cancel anytime\.?\s*/i, 'Pause or cancel anytime to suit you.');
					if ( textNode.parentElement ) {
						textNode.parentElement.classList.add('miles-subscription-policy-copy');
					}
					textNode = textWalker.nextNode();
				}
				this.querySelectorAll('a').forEach(link=>{
					if ( link.textContent.trim().toLowerCase() === 'view subscription policy' ) {
						link.classList.add('miles-subscription-policy-link');
						link.setAttribute('target', '_blank');
						link.setAttribute('rel', 'noopener');
					}
				});
			}

		defaultSubscriptionToOneTime(){
			const activeSubscriptionBlock = this.getActiveSubscriptionBlock();
			if ( ! activeSubscriptionBlock ) {
				return false;
			}

			const oneTimeInput = activeSubscriptionBlock.querySelector('input[data-radio-type="one_time_purchase"]');
			if ( ! oneTimeInput ) {
				return false;
			}

			let selectionChanged = ! oneTimeInput.checked;
			activeSubscriptionBlock.querySelectorAll('input[data-radio-type="selling_plan_group"]').forEach(input=>{
				if ( input.checked ) {
					selectionChanged = true;
				}
				input.checked = false;
				input.removeAttribute('checked');
			});
			this.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]').forEach(input=>{
				if ( input.value !== '' ) {
					selectionChanged = true;
				}
			});
			oneTimeInput.checked = true;
			oneTimeInput.setAttribute('checked', 'checked');
			this.clearSubscriptionSellingPlan();
			if ( selectionChanged ) {
				oneTimeInput.dispatchEvent(new Event('change', { bubbles: true }));
			}
			return true;
		}

		defaultSubscriptionToSubscription(){
			const activeSubscriptionBlock = this.getActiveSubscriptionBlock();
			if ( ! activeSubscriptionBlock ) {
				return false;
			}

			let subscriptionInput = null;
			if ( this.subscriptionSellingPlanGroupValue !== '' ) {
				subscriptionInput = [...activeSubscriptionBlock.querySelectorAll('input[data-radio-type="selling_plan_group"]')].find(input=>{
					return input.value === this.subscriptionSellingPlanGroupValue || input.id === this.subscriptionSellingPlanGroupValue;
				});
			}
			if ( ! subscriptionInput ) {
				subscriptionInput = activeSubscriptionBlock.querySelector('input[data-radio-type="selling_plan_group"]');
			}
			if ( ! subscriptionInput ) {
				return this.defaultSubscriptionToOneTime();
			}

			const oneTimeInput = activeSubscriptionBlock.querySelector('input[data-radio-type="one_time_purchase"]');
			let selectionChanged = ! subscriptionInput.checked;
			this.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]').forEach(input=>{
				if ( input.value === '' ) {
					selectionChanged = true;
				}
			});
			if ( oneTimeInput && oneTimeInput.checked ) {
				selectionChanged = true;
				oneTimeInput.checked = false;
				oneTimeInput.removeAttribute('checked');
			}
			activeSubscriptionBlock.querySelectorAll('input[data-radio-type="selling_plan_group"]').forEach(input=>{
				if ( input !== subscriptionInput && input.checked ) {
					selectionChanged = true;
				}
				input.checked = input === subscriptionInput;
				if ( input === subscriptionInput ) {
					input.setAttribute('checked', 'checked');
				} else {
					input.removeAttribute('checked');
				}
			});
			if ( selectionChanged ) {
				subscriptionInput.dispatchEvent(new Event('change', { bubbles: true }));
			}
			return true;
		}

		requestApplySubscriptionPreference({
			preference = this.subscriptionPurchasePreference,
			delays = [0, 100, 300, 750, 1500, 3000],
			respectCustomerInteraction = false
		} = {}){
			if ( window.MilesSubscriptionWidget ) {
				window.MilesSubscriptionWidget.requestApplySubscriptionPreference(this, {
					preference,
					delays,
					respectCustomerInteraction
				});
				return;
			}

			const requestedAt = Date.now();
			const latestDelay = delays.length > 0 ? Math.max(...delays) : 0;

			this.subscriptionPreferenceRequestedAt = requestedAt;
			this.subscriptionPreferenceUntil = requestedAt + latestDelay + 250;
			this.subscriptionPreferenceRespectCustomerInteraction = respectCustomerInteraction;
			this.subscriptionPreferenceToApply = preference;

			delays.forEach(delay=>{
				setTimeout(()=>{
					this.runApplySubscriptionPreference(requestedAt, respectCustomerInteraction);
				}, delay);
			});
		}

		runApplySubscriptionPreference(requestedAt, respectCustomerInteraction){
			if ( requestedAt !== this.subscriptionPreferenceRequestedAt ) {
				return;
			}
			if ( respectCustomerInteraction && this.subscriptionCustomerInteracted ) {
				return;
			}
			if ( ! respectCustomerInteraction && this.subscriptionCustomerInteractedAt > requestedAt ) {
				return;
			}
			if ( this.subscriptionPreferenceToApply === 'subscription' ) {
				this.defaultSubscriptionToSubscription();
			} else {
				this.defaultSubscriptionToOneTime();
			}
		}

		isOneTimeSubscriptionSelected(){
			if ( window.MilesSubscriptionWidget ) {
				return window.MilesSubscriptionWidget.isOneTimeSubscriptionSelected(this);
			}

			const activeSubscriptionBlock = this.getActiveSubscriptionBlock();
			const oneTimeInput = activeSubscriptionBlock && activeSubscriptionBlock.querySelector('input[data-radio-type="one_time_purchase"]');
			return oneTimeInput ? oneTimeInput.checked : false;
		}

		clearSubscriptionSellingPlan(){
			if ( window.MilesSubscriptionWidget ) {
				window.MilesSubscriptionWidget.clearSubscriptionSellingPlan(this);
				return;
			}

			this.querySelectorAll('input[name="selling_plan"], select[name="selling_plan"]').forEach(input=>{
				input.value = '';
				input.setAttribute('value', '');
			});
		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			this.requestApplySubscriptionPreference();

			let variant = e.target.currentVariant;
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: 'smooth'
							});
						}
					}
				}

			}
		}
	}

  if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
